<template>
  <div>
    <div class="section-title" style="text-align: center; margin-top: 40px;">
      Zapisy na warsztaty
    </div>
    <v-container class="container mt-12" fluid>
      <v-row justify="center" align="baseline">
        <v-col cols="12" sm="6" md="4" lg="6" xl="6">
          <v-card shaped elevation="5"  class="card">
          
            <v-container class=" ">
              <div class="sub-title">Zapisz się do warsztatów</div>
              <ValidationObserver
                ref="obs"
                v-slot="{ invalid, handleSubmit }"
                mode="eager"
              >
                <v-form @submit.prevent="handleSubmit(showConfirmModal)">
                  <VTextFieldWithValidation
                    rules="email|required"
                    v-model="email"
                    label="E-mail"
                    color="grey"
                    outlined
                    dense
                    :disabled="loading"
                  />
                  <div
                    class=""
                    style="display: flex; align-items: center; justify-content: center; padding-top: 50px;"
                  >
                    <v-btn
                      type="submit"
                      class="  primary-button"
                      color="#B7B2AA"
                      style="margin:auto; width: fit-content; color:#8B857D"
                      :loading="loading"
                      :disabled="invalid"
                    >
                      Zapisz się
                    </v-btn>
                  </div>
                </v-form>
              </ValidationObserver>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <confirm-signup-for-sequencing-workshop-modal
      :isVisible="isConfirmModalVisible"
      @closeModal="closeConfirmModal()"
      @confirm="onSubmit"
    />
  </div>
</template>

<script>
import VTextFieldWithValidation from "../../components/inputs/VTextFieldWithValidation";
import { ValidationObserver } from "vee-validate";
import axios from "../../axios";
import router from "../../router";
import ConfirmSignupForSequencingWorkshopModal from "../../components/modals/ConfirmSignupForSequencingWorkshopModal.vue";
export default {
  metaInfo: {
    title:
      "Dagajoga zapisy do wasztatów teoria i praktyka - portal jogi online",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Dagajoga to szkoła internetowa o wszechstronnym systemie budowania praktyki własnej. Praktyka jogi połączona z nowoczesnymi metodami ćwiczeń funkcjonalnych, ćwiczeń wzmacniających.",
      },
    ],
  },
  name: "TheoryPracticeWorkshopSignup",
  components: {
    VTextFieldWithValidation,
    ValidationObserver,
    ConfirmSignupForSequencingWorkshopModal,
  },
  data: () => ({
    email: "",
    loading: false,
    isConfirmModalVisible: false,
  }),
  computed: {
    profile() {
      return this.$store.getters["auth/getProfile"];
    },
  },
  async created() {
    await this.$store.dispatch("auth/fetchUserProfile");
    if (this.profile) {
      this.email = this.profile.email;
      this.isConfirmModalVisible = true;
    }
  },
  destroyed() {},
  methods: {
    showConfirmModal() {
      this.isConfirmModalVisible = true;
    },
    closeConfirmModal() {
      this.isConfirmModalVisible = false;
    },
    async onSubmit() {
      this.loading = true;
      try {
        const response = await this.addToWorkshop();
        if (response.status === 200) {
          if (this.$router.currentRoute.query.id) {
            router.push({
              name: "TheoryPracticeWorkshopPayment",
              params: { id: this.$router.currentRoute.query.id },
            });
          } else {
            router.push({ name: "TheoryPracticeWorkshopSignupSuccess" });
          }
        }
      } catch (error) {
        let errorMessage = "Wystąpił błąd. Spróbuj ponownie";
        if (
          error?.response?.data?.message ===
          "The maximum number of people has already signed up for the workshop"
        ) {
          errorMessage =
            "Do warsztatów zapisała się już maksymalna liczba uczestników";
        }
        this.$store.dispatch(
          "snackbar/setSnackbar",
          {
            color: "red",
            icon: "exclamation-triangle",
            message: errorMessage,
          },
          { root: true }
        );
        this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
        this.loading = false;
      }
    },

    async addToWorkshop() {
      const workshopId = this.$route.params.id;
      return await axios.post(`theoryPracticeWorkshops/${workshopId}/members`, {
        email: this.email,
      });
    },
  },
};
</script>

<style scoped>
.container {
  margin-bottom: 2rem;
}
.reset {
  text-transform: uppercase;
  cursor: pointer;
}
.submit-button {
  background-color: #cc6666 !important;
  font-size: 1.1rem;
}
.card {
  background-color: #d9d9d9;
  color: #54514c;
  border-radius: 32px !important;
  position: relative;
  padding: 40px;
  width: 100%;
  max-width:95vw;
  box-shadow: 0px 0px 100px 25px #b6afa5;
  margin: auto;
}
</style>
